

import { forwardRef, useContext } from 'react';

import { Icon } from '../icon/icon';
import { TextButtonRootContext } from './context/text-button-root.context';
import { textButtonIconRecipe } from './styles/text-button-icon.styles';
import type { TextButtonIconPropsInterface } from './types/text-button-icon.types';

/**
 * @since 10.0.0
 */

export const TextButtonIcon = forwardRef<SVGSVGElement, TextButtonIconPropsInterface>(
  (props: TextButtonIconPropsInterface, forwardedRef) => {
    const { tone, disabled, onImpact, textStyle } = useContext(TextButtonRootContext);
    const { children, css: cssProp, size, ...rest } = props;

    // Match icon size to the text style
    const iconSizeByTextStyle = textStyle == 'body-sm' || textStyle == 'body-sm-bold' ? 'sm' : 'md';

    return (
      <Icon
        ref={forwardedRef}
        data-c11n-component="TextButton.Icon"
        data-c11n-version={__C11N_VERSION__}
        css={{
          ...textButtonIconRecipe.raw({ tone, onImpact, disabled, size }),
          ...cssProp,
        }}
        size={size || iconSizeByTextStyle || 'md'}
        {...rest}
      >
        {children}
      </Icon>
    );
  },
);

TextButtonIcon.displayName = 'TextButton.Icon';
